import axios from 'axios';
import api_url from '../urls';
const actions = {

  async  PegarProcessoId (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
        
     await axios.post(api_url.api_admin + 'processo_id',
        {
            shop_process_id: value.shop_process_id,
            amount: value.amount,
            currency:value.currency,
            additional_data: value.additional_data,
            description: value.description,
            return_url: value.return_url,
            cancel_url: value.cancel_url
        },
        {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            // console.log(response.data.process_id);
            context.commit('SET_PROCESSO_ID', response.data.process_id)
        })
        .catch((error) => {
            console.log(error.response.data.message);
            context.commit('SET_PROCESSO_ID', '')
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    },
    
    Confirmar_pagamento (context, value) {

     context.commit('PRELOADER_MUDAR',true)
      
      const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
       axios.get(api_url.api_admin + 'confirmar_pagamento/'+ value,
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           console.log(response.data);
        // context.commit('ALL_CURSOS', response.data)
      })
      .catch((error) => {
          console.log(error.response.data.message);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
  Rollback (context, value) {

    context.commit('PRELOADER_MUDAR',true)
     
     const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
      axios.get(api_url.api_admin + 'rollback/'+ value,
      {
         headers: {
             'authorization': AuthStr,
             'Accept' : 'application/json',
             'Content-Type': 'application/json'
         }
     })
     .then(response => {
          console.log(response.data);
       //  context.commit('ALL_CURSOS', response.data)
     })
     .catch((error) => {
         console.log(error.response.data.message);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
     
    },
 Faturas_aluno (context, value) {
    

    context.commit('PRELOADER_MUDAR',true)
     
     const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
      axios.get(api_url.api_admin + 'v1/admin/faturas_aluno/'+ localStorage.getItem('aluno_id'),
      {
         headers: {
             'authorization': AuthStr,
             'Accept' : 'application/json',
             'Content-Type': 'application/json'
         }
     })
     .then(response => {
          console.log(response.data);
        context.commit('SET_FATURAS_ALUNO', response.data)
     })
     .catch((error) => {
         console.log(error.response.data.message);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
     
 },
    async  Add_fatura_carrinho (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
        
        await axios.post(api_url.api_admin + 'add_fatura_carrinho',
            {
                value: value,
                aluno_id: localStorage.getItem('aluno_id'),
            
            },
            {
                headers: {
                    'Authorization': AuthStr,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                console.log(response.data);
                context.commit('SET_FATURAS_INSERIDAS', response.data)
            })
            .catch((error) => {
                console.log(error.response.data.message);
             //   context.commit('SET_PROCESSO_ID', '')
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    },
    async  Remover_fatura_carrinho (context, value) {
        console.log(value)
        context.commit('PRELOADER_MUDAR',true)
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
        
        await axios.post(api_url.api_admin + 'v1/admin/eliminar_fatura_carrinho',
            {
                value: value,
                aluno_id: localStorage.getItem('aluno_id'),
            
            },
            {
                headers: {
                    'Authorization': AuthStr,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                console.log(response.data);
                context.commit('SET_FATURAS_INSERIDAS', response.data)
            })
            .catch((error) => {
                console.log(error.response.data.message);
             //   context.commit('SET_PROCESSO_ID', '')
            }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    },
    allProdutos (context) {

        context.commit('PRELOADER_MUDAR',true)
         
         const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
          axios.get(api_url.api_admin + 'v1/admin/allprodutos',
          {
             headers: {
                 'authorization': AuthStr,
                 'Accept' : 'application/json',
                 'Content-Type': 'application/json'
             }
         })
         .then(response => {
              console.log(response.data);
            context.commit('ALL_PRODUTOS', response.data)
         })
         .catch((error) => {
             console.log(error.response.data.message);
           }).finally(()=> context.commit('PRELOADER_MUDAR',false))
         
     },
     addFaturas (context,value) {

        context.commit('PRELOADER_MUDAR',true)
         
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
        axios.post(api_url.api_admin + 'v1/admin/add_fatura_aluno',
          {
            value
        },
          {
             headers: {
                 'authorization': AuthStr,
                 'Accept' : 'application/json',
                 'Content-Type': 'application/json'
             }
         })
         .then(response => {
              console.log(response.data);
           // context.commit('ALL_PRODUTOS', response.data)
         })
         .catch((error) => {
             console.log(error.response.data.message);
           }).finally(()=> context.commit('PRELOADER_MUDAR',false))
         
     },
     async  GerarVendaId (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
        
     await axios.post(api_url.api_admin + 'gerar_venda',
        {
            shop_process_id: value.shop_process_id,
            amount: value.amount,
            currency:value.currency,
            additional_data: value.additional_data,
            description: value.description,
            return_url: value.return_url,
            cancel_url: value.cancel_url
        },
        {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            // console.log(response.data.process_id);
            context.commit('SET_PROCESSO_ID', response.data.process_id)
        })
        .catch((error) => {
            console.log(error.response.data.message);
            context.commit('SET_PROCESSO_ID', '')
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    },

   async editFaturas (context,value) {
           
        context.commit('PRELOADER_MUDAR',true)
         
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
      await  axios.post(api_url.api_admin + 'v1/admin/edit_fatura_aluno',
          {
            id: value.id,
            valor: value.valor,
            aluno_id: value.aluno_id,
            data_pagamento: value.data_pagamento,
            data_vencimento: value.data_vencimento,
            status_venda:value.status_venda,
            status:value.status
            
       
        },
          {
             headers: {
                 'authorization': AuthStr,
                 'Accept' : 'application/json',
                 'Content-Type': 'application/json'
             }
         })
         .then(response => {
              console.log(response.data);
           // context.commit('ALL_PRODUTOS', response.data)
         })
         .catch((error) => {
             console.log(error.response.data.message);
           }).finally(()=> context.commit('PRELOADER_MUDAR',false))
         
     },
}

export default actions